module.exports = __webpack_public_path__ + "img/学生绑定.b7e5192f.png";